/** Ids of the tenants (and sub-tenants) the user picked last, most recent first. Stored per browser. */
const STORAGE_KEY = 'tenant:recent';
const LIMIT = 5;

export const readRecentTenantIds = (): string[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is string => typeof id === 'string').slice(0, LIMIT);
  } catch {
    return [];
  }
};

export const pushRecentTenantId = (tenantId: string): void => {
  try {
    const rest = readRecentTenantIds().filter((id) => id !== tenantId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify([tenantId, ...rest].slice(0, LIMIT)));
  } catch {
    // Storage is not available, the list just will not remember choices
  }
};
